(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Kart içi görsel değiştirme (thumb noktaları) + ürün ana görsel swiper'ı.
  DNB.Gallery = {
    init: function () {
      var cards = document.querySelectorAll("[data-gallery]");
      Array.prototype.forEach.call(cards, bindGallery);

      var medias = document.querySelectorAll("[data-product-media]");
      Array.prototype.forEach.call(medias, bindMedia);

      var mores = document.querySelectorAll(".product-intro__more");
      Array.prototype.forEach.call(mores, bindMore);
    }
  };

  var MORE_LINES = 5;
  var MORE_CHARS = 600;

  // ---- Ürün açıklaması "Daha Fazla Göster" — 600 karakter ve taşma varsa ----
  function bindMore(btn) {
    if (btn.getAttribute("data-more-init") === "1") return;
    btn.setAttribute("data-more-init", "1");

    var root = btn.closest ? btn.closest(".product-intro") : null;
    var desc = root ? root.querySelector(".product-intro__desc") : null;
    if (!root || !desc) {
      btn.hidden = true;
      return;
    }

    var userOpen = false;

    function plainLength() {
      return (desc.textContent || "").replace(/\s+/g, " ").trim().length;
    }

    function decide() {
      if (userOpen) return;
      root.classList.remove("is-clamped", "is-expanded");
      var line = parseFloat(window.getComputedStyle(desc).lineHeight) || 34;
      var full = desc.scrollHeight;
      var overflows = full > (line * MORE_LINES) + 2;
      var show = plainLength() > MORE_CHARS && overflows;
      btn.hidden = !show;
      root.classList.toggle("is-clamped", show);
    }

    decide();
    window.addEventListener("resize", decide);

    btn.addEventListener("click", function () {
      userOpen = !root.classList.contains("is-expanded");
      root.classList.toggle("is-expanded", userOpen);
      root.classList.toggle("is-clamped", !userOpen);
      var moreLabel = btn.getAttribute("data-more-label") || "Daha Fazla Göster";
      var lessLabel = btn.getAttribute("data-less-label") || "Daha Az Göster";
      var icon = btn.querySelector(".icon");
      btn.textContent = (userOpen ? lessLabel : moreLabel) + " ";
      if (icon) btn.appendChild(icon);
    });
  }

  // ---- Kart galeri: imleç konumuna göre görsel (alan 100/n) ----
  function bindGallery(g) {
    if (g.getAttribute("data-gallery-init") === "1") return;
    g.setAttribute("data-gallery-init", "1");

    var media = g.querySelector(".pcard__media");
    var imgs = g.querySelectorAll(".pcard__img");
    var dots = g.querySelectorAll(".pcard__dot");
    if (!media || imgs.length < 2) return;

    var current = 0;

    function show(index) {
      if (index === current) return;
      current = index;
      setActive(imgs, index);
      setActive(dots, index);
    }

    media.addEventListener("mousemove", function (e) {
      var rect = media.getBoundingClientRect();
      if (!rect.width) return;
      var ratio = (e.clientX - rect.left) / rect.width;
      var index = Math.floor(ratio * imgs.length);
      if (index < 0) index = 0;
      if (index > imgs.length - 1) index = imgs.length - 1;
      show(index);
    });

    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        current = -1;
        show(i);
      });
    });
  }

  function setActive(list, index) {
    Array.prototype.forEach.call(list, function (el, i) {
      el.classList.toggle("is-active", i === index);
    });
  }

  // ---- Ürün ana görseli: 1'den fazla görsel varsa swiper + nav ----
  function bindMedia(m) {
    if (m.getAttribute("data-product-media-init") === "1") return;
    m.setAttribute("data-product-media-init", "1");

    var track = m.querySelector("[data-pm-track]");
    var nav = m.querySelector("[data-pm-nav]");
    if (!track) return;

    var slides = track.querySelectorAll(".swiper-slide");
    if (slides.length < 2) {
      if (nav) nav.style.display = "none";
      return;
    }
    if (!window.Swiper) return;

    var counter = m.querySelector("[data-pm-counter]");
    var prev = m.querySelector("[data-pm-prev]");
    var next = m.querySelector("[data-pm-next]");

    var swiper = new window.Swiper(track, {
      slidesPerView: 1,
      speed: 500,
      on: {
        init: update,
        slideChange: update
      }
    });

    function update(sw) {
      if (counter) counter.textContent = (sw.activeIndex + 1) + " / " + sw.slides.length;
      if (prev) prev.disabled = sw.isBeginning;
      if (next) next.disabled = sw.isEnd;
    }

    if (prev) prev.addEventListener("click", function () { swiper.slidePrev(); });
    if (next) next.addEventListener("click", function () { swiper.slideNext(); });
  }
})(window, document);
